import { useState } from 'react';
import { Box, useTheme } from '@mui/material';
import Header from 'components/Layouts/components/Header';
// import Sidebar from './components/Sidebar';
import SidebarDynamic from './components/SidebarDynamic';

type Props = {
  children: JSX.Element;
};

export default function WorksheetLayout({ children }: Props) {
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <Header onMenuClick={handleDrawerToggle} />
      <Box bgcolor={theme.palette.background.default} display='flex' position={'relative'}>
        <SidebarDynamic isMenuOpen={mobileOpen} handleClose={handleDrawerToggle} />
        <Box component='main' width='100%' p={3} flexGrow={1} pt='88px' position='absolute' pl={12}>
          {children}
        </Box>
      </Box>
    </>
  );
}
